import _sortBy from 'lodash/sortBy';
import Lucene from 'services/lucene';

import FolderBrowserController from '../popups/folder-browser/controller';

const folderBrowserTemplate = require('../popups/folder-browser/template.html');

const DEFAULT_TAB_INDEX = 0;

export default class SensorTabsController {
    /** @ngInject */
    constructor(EventEmitter, NavigationService, DialogService, $state, $scope) {
        this.EventEmitter = EventEmitter;
        this.NavigationService = NavigationService;
        this.DialogService = DialogService;
        this.$state = $state;
        this.$scope = $scope;
    }

    get currentTabIndex() {
        const tabIndex = this.findTabIndexByItemId(this.tabId);
        return tabIndex < 0 ? DEFAULT_TAB_INDEX : tabIndex;
    }

    /**
     * Intentionally empty setter since we use purely computed value
     * @param tabIndex
     */
    set currentTabIndex(tabIndex) {} // eslint-disable-line

    get defaultNavigationItems() {
        return [
            {
                title: 'Overview',
                search_query: ''
            },
            {
                title: 'Folders',
                id: 'folders',
                icon: 'folder_open',
                callback: () => this.DialogService.show({
                    controller: FolderBrowserController,
                    controllerAs: '$ctrl',
                    template: folderBrowserTemplate,
                    parent: document.body,
                    openFrom: 'top',
                    closeTo: 'top',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    fullscreen: true,
                    locals: {
                        folderChangedCallback: (folderId) => {
                            if (folderId) {
                                this.loadTabData(Lucene.convertFoldersToLuceneCompatible([folderId]), 'folders');
                            }
                        },
                    }
                })
            }
        ];
    }

    $onInit() {
        this.tabs = this.defaultNavigationItems;
        this.loadAppNavigation();
    }

    loadAppNavigation() {
        return this.NavigationService.getSensorsAndConnectors().then((data) => {
            this.tabs = [
                ...this.defaultNavigationItems,
                ..._sortBy(SensorTabsController.processNavigationData(data.objects), 'position')
            ];
        });
    }

    static processNavigationData(data) {
        return data.map((item) => {
            item.title = item.name;

            if (item.children) {
                item.items = item.children.map((view) => {
                    view.title = view.name;
                    return view;
                });

                const queries = item.items.map(view => view.search_query);
                item.search_query = `(${queries.join(') OR (')})`;
            }

            if (!item.search_query) {
                item.disabled = true;
            }

            return item;
        });
    }

    onSaveView({ view }) {
        this.loadAppNavigation().then(() => {
            this.loadTabData(view.search_query, view.id);
        });
    }

    findTabIndexByItemId(itemId) {
        return this.tabs.findIndex((tab) => {
            const isThisTab = tab.id === itemId;

            if (tab.children && !isThisTab) {
                return tab.children.find(view => view.id === itemId);
            }

            return isThisTab;
        });
    }

    loadTabData(q, tabId) {
        this.$state.go('main.sensors.list', {
            q,
            tabId
        });
    }

    onTabClick({ tab }) {
        if (tab.callback) {
            tab.callback();
        } else {
            this.loadTabData(tab.search_query, tab.id);
        }
    }

    onTabMenuItemClick({ item }) {
        this.loadTabData(item.search_query, item.id);
    }
}




// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/tabs/tabs.controller.js